<section class="overview-section" *ngIf="canDisplayDetails">
  <h5>{{'admin.strain.tickets.reports.modal.step8.sections.details.title' | translate}}</h5>
  <div class="details-grid">
    <div class="details-column">
      <app-display-label
        [inlineLabel]="true"
        label="{{'admin.strain.tickets.reports.modal.step8.sections.details.sampleRate' | translate}}"
        [value]="measurement.details.frequency.filterValue"
        [valueStyle]="{'color': '#2B4D84'}">
      </app-display-label>
      <app-display-label
        [inlineLabel]="true"
        label="{{'admin.strain.tickets.reports.modal.step8.sections.details.measurementEquipment' | translate}}"
        [value]="measurement.details.measuringEquipment.name"
        [valueStyle]="{'color': '#2B4D84'}">
      </app-display-label>
      <app-display-label
        [inlineLabel]="true"
        label="{{'admin.strain.tickets.reports.modal.step8.sections.details.processResponsible' | translate}}"
        [value]="measurement.details.responsible"
        [valueStyle]="{'color': '#2B4D84'}">
      </app-display-label>
      <app-display-label
        [inlineLabel]="true"
        label="{{'admin.strain.tickets.reports.modal.step8.sections.details.testType' | translate}}"
        [value]="measurement.details.measurementType.name"
        [valueStyle]="{'color': '#2B4D84'}">
      </app-display-label>
      <app-display-label
        [inlineLabel]="true"
        label="{{'admin.strain.tickets.reports.modal.step8.sections.details.environmentConditions' | translate}}"
        [value]="conditions"
        [valueStyle]="{'color': '#2B4D84'}">
      </app-display-label>
      <app-display-label
        [inlineLabel]="true"
        label="{{'admin.strain.tickets.reports.modal.step8.sections.details.executionMode' | translate}}"
        [value]="measurement.details.measurementMethod.name"
        [valueStyle]="{'color': '#2B4D84'}">
      </app-display-label>
    </div>
    <div class="details-column">
      <app-display-label
        [inlineLabel]="true"
        label="{{'admin.strain.tickets.reports.modal.step8.sections.details.gageAdhesive' | translate}}"
        [value]="measurement.gageMounting.adhesive.name"
        [valueStyle]="{'color': '#2B4D84'}">
      </app-display-label>
      <app-display-label
        [inlineLabel]="true"
        label="{{'admin.strain.tickets.reports.modal.step8.sections.details.mounterOfGages' | translate}}"
        [value]="measurement.gageMounting.mountedBy.fullName"
        [valueStyle]="{'color': '#2B4D84'}">
      </app-display-label>
      <app-display-label
        [inlineLabel]="true"
        label="{{'admin.strain.tickets.reports.modal.step8.sections.details.dateOfMounting' | translate}}"
        [value]="measurement.gageMounting.mountingDate | date: 'dd/MM/yyyy'"
        [valueStyle]="{'color': '#2B4D84'}">
      </app-display-label>
      <app-display-label
        [inlineLabel]="true"
        label="{{'admin.strain.tickets.reports.modal.step8.sections.details.evaluator' | translate}}"
        [value]="measurement.gageMounting.evaluatedBy"
        [valueStyle]="{'color': '#2B4D84'}">
      </app-display-label>
      <app-display-label
        [inlineLabel]="true"
        label="{{'admin.strain.tickets.reports.modal.step8.sections.details.dateOfEvaluation' | translate}}"
        [value]="measurement.gageMounting.evaluationDate | date: 'dd/MM/yyyy'"
        [valueStyle]="{'color': '#2B4D84'}">
      </app-display-label>
    </div>
  </div>
</section>

<section class="overview-section" *ngIf="canDisplayImages">
  <h5>{{'admin.strain.tickets.reports.modal.step8.sections.gageDetails.title' | translate}}</h5>
  <div class="measurement-card" *ngFor="let image of measurement.images; let i = index">
    <strong>{{'admin.strain.tickets.reports.modal.step8.sections.gageDetails.measurement' | translate}} {{i + 1}}</strong>
    <p>{{'admin.strain.tickets.reports.modal.step8.sections.gageDetails.observations' | translate}}: <span class="blue-text">{{image.observations}}</span></p>
    <p>{{'admin.strain.tickets.reports.modal.step8.sections.gageDetails.nrOfGages' | translate}}: <span class="blue-text">{{image.gages.length}}</span></p>
    <div class="gage-list">
      <p class="gage-item" *ngFor="let gage of image.gages; let j = index">
        {{j + 1}}. {{'admin.strain.tickets.reports.modal.step3.gageType' | translate}}: <span class="blue-text">{{gage.gage.type}}</span> |
        {{'admin.strain.tickets.reports.modal.step8.sections.gageDetails.type.name' | translate}}:
        <span class="blue-text">{{'admin.strain.tickets.reports.modal.step8.sections.gageDetails.type.' + gage.gage.model | translate}}</span> |
        {{'admin.strain.tickets.reports.modal.step8.sections.gageDetails.name' | translate}}: <span class="blue-text">{{gage.name}}</span> |
        {{'admin.strain.tickets.reports.modal.step8.sections.gageDetails.position.name' | translate}}:
        <span class="blue-text">{{'admin.strain.tickets.reports.modal.step8.sections.gageDetails.position.' + gage.position | translate}}</span>
      </p>
    </div>
    <div class="content-grid">
      <div class="content-column" *ngIf="image.frontSideImage">
        <p>{{'admin.strain.tickets.reports.modal.step8.sections.gageDetails.topImage' | translate}}</p>
        <div class="media-frame">
          <img [src]="getGageImageUrl(image)" class="media-image">
        </div>
      </div>
      <div class="content-column" *ngIf="image.backSideImage">
        <p>{{'admin.strain.tickets.reports.modal.step8.sections.gageDetails.bottomImage' | translate}}</p>
        <div class="media-frame">
          <img [src]="getGageImageUrl(image, true)" class="media-image">
        </div>
      </div>
    </div>
  </div>
</section>

<section class="overview-section" *ngIf="canDisplayMeasurements">
  <h5>{{'admin.strain.tickets.reports.modal.step8.sections.measurements.title' | translate}}</h5>
  <p>{{'admin.strain.tickets.reports.modal.step8.sections.measurements.justifications' | translate}}: <span class="blue-text">{{measurement?.gageCharts[0]?.reason?.name}}</span></p>
  <div class="measurement-card" *ngFor="let chart of measurement.gageCharts; let i = index">
    <strong>{{'admin.strain.tickets.reports.modal.step8.sections.measurements.measurementTitle' | translate}}: <span class="blue-text">{{chart.title}}</span></strong>
    <p>{{'admin.strain.tickets.reports.modal.step8.sections.measurements.observations' | translate}}: <span class="blue-text">{{chart.observations}}</span></p>

    <div class="content-grid">
      <div class="content-column" *ngIf="chart.measurementChart">
        <p>{{'admin.strain.tickets.reports.modal.step8.sections.measurements.measurementChart' | translate}}</p>
        <div class="media-frame">
          <img [src]="getChartImageUrl(chart.measurementChart)" class="media-image">
        </div>
      </div>
      <div class="content-column" *ngIf="chart.gageValues">
        <p>{{'admin.strain.tickets.reports.modal.step8.sections.measurements.measurementValues' | translate}}</p>
        <div class="table-frame">
          <app-table [data]="chart.gageValues">
            <app-table-column *ngFor="let column of columns"
                        header="{{('admin.strain.common.excelPaste.columns.' + column.value) | translate}}"
                        field="{{column.value}}">
            </app-table-column>
        </app-table>
        </div>
      </div>
    </div>
  </div>
</section>
